import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import * as com from "./Common.js"

// "Borrower application": the borrower portal for this loan, signed in as its
// borrower. The LOS asks the server for a one-time ticket for the loan (only
// a loan officer who may see the loan gets one) and opens the portal page it
// names with the ticket in the URL fragment; the portal trades the ticket for
// the borrower session. See web/go/src/borrower_view_for_loan_officer.go.
const InterviewBorrowerView = (props) => {
  const location = useLocation();
  const pathSections = location.pathname.split('/');
  const loanid = props.loanId || pathSections[pathSections.length - 1];
  const [frameSrc, setFrameSrc] = useState("")
  const [error, setError] = useState("")

  useEffect(() => {
    let cancelled = false
    setFrameSrc("")
    setError("")
    fetch('/los/borrowerviewticket', {
      method: 'POST',
      body: JSON.stringify({ LoanID: loanid }),
      headers: {
        Authorization: "Bearer " + com.getUserToken(),
        "Content-Type": "application/json",
      },
    }).then(response => {
      if (!response.ok) {
        throw new Error(response.status === 403 ? "You don't have access to this loan." : "Could not open the borrower's application.")
      }
      return response.json()
    }).then(js => {
      if (!cancelled) setFrameSrc(js.URL + "#ticket=" + encodeURIComponent(js.Ticket))
    }).catch(err => {
      if (!cancelled) setError(err.message || "Could not open the borrower's application.")
    })
    return () => { cancelled = true }
  }, [loanid])

  return (
    <>
      <div className="text-center" style={{paddingTop:"20px",paddingBottom:"10px",color:"#202020d1",fontWeight:"700",fontSize:"20px"}}>Monitor your borrower's progress on their application.</div>
      <div className="borrowerViewWrap" style={{display:"flex",justifyContent:"center"}}>
        {error && <div className="text-center" style={{paddingTop:"20px"}}>{error}</div>}
        {frameSrc && (
          <iframe
            title="Borrower application"
            src={frameSrc}
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
            referrerPolicy="no-referrer"
            style={{border:"none",height:"100%",width:"100%",margin:"10px"}}
          />
        )}
      </div>
    </>
  );
};

export default InterviewBorrowerView;